import { cx } from '@linaria/core';
import { NotificationBadge } from '@pm2/react-utils';
import { Row, Cell } from '@ui/kit';
import { formatTimestamp } from '@utils/common';
import { FormattedList } from '@utils/react';
import { shortenLevel } from '../../utils/shorten-level.js';
import { rowSizingCls, rowOverridesCls, mobileContentWrapperCls, mobileHeadingCls, mobileMetaCls, mobileDateCls } from './_course-item.style.js';
import { Actions } from './actions.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

const courseItemIdentifier = "course-builder--course-item";
const courseItemSelector = `.${courseItemIdentifier}`;
function CourseItem(props) {
  return /*#__PURE__*/jsx(Row, {
    sizingCls: rowSizingCls,
    className: cx(courseItemIdentifier, rowOverridesCls, props.className, props.mobileLayout && "mobile", props.panelLayout && "inPanel"),
    onClick: props.onCourseClick,
    "aria-label": "Aktiver forl\xF8b",
    children: props.mobileLayout || props.panelLayout ? /*#__PURE__*/jsx(MobileLayout, {
      ...props
    }) : /*#__PURE__*/jsx(DesktopLayout, {
      ...props
    })
  });
}
function DesktopLayout(props) {
  // Parse levels and reduce them to their minimum representative value, e.g.
  // "1. klasse" -> "1."
  const shortenedLevels = props.item.levels.map(shortenLevel);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Cell, {
      role: "rowheader",
      children: props.item.title
    }), /*#__PURE__*/jsx(Cell, {
      children: props.new ? /*#__PURE__*/jsx(NotificationBadge, {
        children: "NYT"
      }) : formatTimestamp(props.item.modifiedAt)
    }), /*#__PURE__*/jsx(Cell, {
      tooltip: /*#__PURE__*/jsx(FormattedList, {
        children: props.item.levels
      }),
      children: /*#__PURE__*/jsx(FormattedList, {
        finalSep: ", ",
        children: shortenedLevels.length > 1 ? shortenedLevels : props.item.levels
      })
    }), /*#__PURE__*/jsx(Cell, {
      children: /*#__PURE__*/jsx(FormattedList, {
        children: props.item.subjects
      })
    }), !props.simpleLayout && /*#__PURE__*/jsx(Actions, {
      item: props.item,
      onActionClick: props.onActionClick
    })]
  });
}
function MobileLayout(props) {
  return /*#__PURE__*/jsxs("div", {
    className: mobileContentWrapperCls,
    children: [/*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx(Cell, {
        className: mobileHeadingCls,
        role: "rowheader",
        children: props.item.title
      }), /*#__PURE__*/jsxs("div", {
        className: mobileMetaCls,
        children: [props.item.subjects.length > 0 && /*#__PURE__*/jsx(Cell, {
          children: /*#__PURE__*/jsx(FormattedList, {
            children: props.item.subjects
          })
        }), props.item.levels.length > 0 && /*#__PURE__*/jsx(Cell, {
          tooltip: /*#__PURE__*/jsx(FormattedList, {
            children: props.item.levels
          }),
          children: /*#__PURE__*/jsx(FormattedList, {
            children: props.item.levels
          })
        })]
      })]
    }), /*#__PURE__*/jsx(Cell, {
      className: mobileDateCls,
      children: props.new ? /*#__PURE__*/jsx(NotificationBadge, {
        children: "NYT"
      }) : formatTimestamp(props.item.modifiedAt)
    })]
  });
}

export { CourseItem, courseItemSelector };
//# sourceMappingURL=_course-item.js.map
